import { NavLink } from 'react-router-dom'
import {
  StatsIcon,
  RocketIcon,
  HomeIcon,
  CogIcon,
  MobileIcon,
  FlagIcon,
  UserGroupIcon,
  CloseIcon,
  LightningBoltIcon,
  QuestionCircleIcon,
} from '@nimbus-ds/icons'
import { Text } from '@nimbus-ds/components'
import { cn } from '@/lib/utils'
import { useAuth } from '@/hooks/useAuth'
import { StoreSwitcher } from './StoreSwitcher'

const navigation = [
  { name: 'Resumen', href: '/dashboard', icon: HomeIcon },
  { name: 'Objetivos', href: '/dashboard/goals', icon: FlagIcon },
  { name: 'Preguntas', href: '/dashboard/questions', icon: QuestionCircleIcon },
  { name: 'Experimentos', href: '/dashboard/experiments', icon: RocketIcon },
  { name: 'Eventos Personalizados', href: '/dashboard/custom-events', icon: LightningBoltIcon },
  { name: 'Cohortes', href: '/dashboard/cohorts', icon: UserGroupIcon },
  { name: 'Resultados', href: '/dashboard/results', icon: StatsIcon },
  { name: 'Vista comerciante', href: '/merchant', icon: MobileIcon },
  { name: 'Configuración', href: '/dashboard/settings', icon: CogIcon },
]

interface SidebarProps {
  onNavigate?: () => void
}

export function Sidebar({ onNavigate }: SidebarProps = {}) {
  const { user } = useAuth()

  return (
    <div className="flex h-full w-64 flex-col border-r bg-card">
      {/* Logo */}
      <div className="flex h-16 items-center justify-between px-6">
        <div className="flex items-center space-x-3">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-[var(--nimbus-colors-primary-interactive)]">
            <RocketIcon size={20} className="text-white" />
          </div>
          <div>
            <Text fontWeight="bold" color="neutral-textHigh">ECommerceLab Desk</Text>
            <Text fontSize="caption">Plataforma CRO</Text>
          </div>
        </div>
        {onNavigate && (
          <button
            type="button"
            onClick={onNavigate}
            aria-label="Cerrar menu"
            className="-mr-2 flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:bg-muted hover:text-foreground lg:hidden"
          >
            <CloseIcon size={20} />
          </button>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 space-y-1 px-3 py-4">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.href}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'group flex items-center rounded-md px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'border-r-2 border-[var(--nimbus-colors-primary-interactive)] bg-[var(--nimbus-colors-primary-surface)] text-[var(--nimbus-colors-primary-textHigh)]'
                  : 'text-muted-foreground hover:bg-muted hover:text-foreground'
              )
            }
            end={item.href === '/dashboard'}
          >
            <item.icon size={20} className="mr-3 shrink-0" />
            {item.name}
          </NavLink>
        ))}
      </nav>

      {/* Bottom section — store picker (visible in mobile drawer + desktop sidebar) */}
      <div className="border-t p-4 space-y-3">
        <div className="uppercase tracking-wide">
          <Text fontSize="caption" fontWeight="medium">Tienda actual</Text>
        </div>
        <StoreSwitcher />
        {user?.email && (
          <div className="truncate" title={user.email}>
            <Text fontSize="caption">{user.email}</Text>
          </div>
        )}
      </div>
    </div>
  )
}
